
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import SEOHead from '../../components/base/SEOHead';

const MissionVisionPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <SEOHead 
        title="Mission & Vision - HP Inc Consulting Services | Our Safety Commitment"
        description="Learn about HP Inc Consulting Services mission and vision for workplace safety excellence. Our commitment to providing professional safety consulting and OSHA compliance services."
        keywords="safety consulting mission, workplace safety vision, safety company values, OSHA compliance commitment, professional safety services mission, safety consulting philosophy"
        canonical="https://hpincconsultant.com/mission-vision"
        ogTitle="Mission & Vision - HP Inc Consulting Services"
        ogDescription="Discover our mission and vision for workplace safety excellence and our commitment to professional safety consulting services."
        ogUrl="https://hpincconsultant.com/mission-vision"
      />
      <Header />
      <main>
        {/* Hero Section */}
        <section className="relative bg-gradient-to-r from-blue-900 to-blue-700 text-white py-20">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto text-center">
              <h1 className="text-4xl md:text-5xl font-bold mb-6">
                Mission &amp; Vision
              </h1>
              <p className="text-xl mb-8">
                Our commitment to workplace safety and excellence
              </p>
            </div>
          </div>
        </section>

        {/* Mission & Vision Section */}
        <section className="py-16">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto">
              <div className="grid md:grid-cols-2 gap-12">
                <div>
                  <h2 className="text-3xl font-bold mb-6 text-blue-900">Our Mission</h2>
                  <p className="text-gray-600 text-lg leading-relaxed">
                    To provide comprehensive safety consulting services that protect workers, 
                    ensure regulatory compliance, and create safer work environments for businesses 
                    across all industries. We are committed to delivering expert guidance and 
                    practical solutions that make a real difference in workplace safety.
                  </p>
                </div>
                <div>
                  <h2 className="text-3xl font-bold mb-6 text-blue-900">Our Vision</h2>
                  <p className="text-gray-600 text-lg leading-relaxed">
                    To be the leading safety consulting firm recognized for our expertise, 
                    integrity, and commitment to creating injury-free workplaces. We envision 
                    a future where every worker returns home safely every day, and every 
                    business operates with the highest safety standards.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default MissionVisionPage;
